import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { useHeadingSectionIndexedMeasure } from './hooks';
import { MediaContext } from '../../../../MediaContext';

export const MeasuredTitleContainer = (props: React.PropsWithChildren<{
  height: number,
  color: ouiStyle.InStyle['color'],
  setHeight: any,
}>) => {
  const {
    height,
    color,
    setHeight,
    children,
  } = props;
  const [observe] = useHeadingSectionIndexedMeasure(setHeight);
  const { upMd } = React.useContext(MediaContext);
  return (
    <div
      style={upMd ? {
        height,
      } : {}}
    >
      <ouiDom.HeadingSection.DomH3WithRef
        ref={observe}
        color={color}
      >
        {children}
      </ouiDom.HeadingSection.DomH3WithRef>
    </div>
  );
};
